import ltiDisplayViewSelector from './lti_display_view_selector'
import ltiDataSelector from './lti_data_selector'

export default {
	ltiDisplayViewSelector,
	ltiDataSelector,
}
